module.exports = __webpack_public_path__ + "static/media/pasamosagostomini.4ecd1c7a.webp";